import { render, staticRenderFns } from "./StartedProjectsPage.vue?vue&type=template&id=31b90c6c&scoped=true"
import script from "./StartedProjectsPage.vue?vue&type=script&lang=ts"
export * from "./StartedProjectsPage.vue?vue&type=script&lang=ts"
import style0 from "./StartedProjectsPage.vue?vue&type=style&index=0&id=31b90c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b90c6c",
  null
  
)

export default component.exports